export default __webpack_public_path__ + "static/media/ntc big logo.f7b11775.png";